const tua = {
  FORMS: [
    {
      type: 'tua-dudas-compra',
      name: 'TUADudasCompraForm',
      message: {
        open: 'Opción Dudas Compra',
        send: 'Envío Formulario De Dudas Compra'
      }
    },
    {
      type: 'tua-problemas-compra',
      name: 'TUAProductosProblemasForm',
      message: {
        open: 'Opción Problemas Productos',
        send: 'Envío Formulario Problemas Productos'
      }
    },
    {
      type: 'tua-devolucion-pedidos',
      name: 'TUADevolucionPedidosForm',
      message: {
        open: 'Opción Devolucion Pedidos',
        send: 'Envío Formulario Devolucion Pedido'
      }
    },
    {
      type: 'tua-contacto',
      name: 'TUAContactoForm',
      message: {
        open: 'Opción Contacto',
        send: 'Envío Formulario Contacto'
      }
    }
  ],
  CSS: {
    id: '5f9c22b61637a942465a7980',
    name: 'tua',
    avatar: {
      name: 'TUA',
      header: 'https://chatbotqa.gatblac.com/static/avatar/tua/tua-blanco.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/tua/tua.gif',
      open: 'https://chatbotqa.gatblac.com/static/avatar/tua/chat-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/tua/chat-close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#84b9b8',
        borderColor: '#84b9b8'
      }
    }
  }
}

export default tua
